export default "__VITE_ASSET__4798f8c6__"